import V2 from "./v2/launch-ui";

export default function Entry(props) {
    return <V2 {...props} />;
}
